/** @format */

import {SortingFn} from '@tanstack/react-table';

import {TanStackTableData} from 'components/Table/core/types';

const getDateTime = (timeString: string) => {
  return new Date(timeString);
};

export const alphabeticalWithDateSorting: SortingFn<TanStackTableData> = (rowA, rowB, columnId) => {
  const valueA = ((rowA.getValue(columnId) as string) || '').toLowerCase();
  const valueB = ((rowB.getValue(columnId) as string) || '').toLowerCase();

  const alphabeticalComparison = valueA.localeCompare(valueB, 'ru');

  if (alphabeticalComparison !== 0) {
    return alphabeticalComparison;
  }

  return dateSorting(rowA, rowB, 'time');
};

export const dateSorting: SortingFn<TanStackTableData> = (rowA, rowB, columnId) => {
  const timeA = rowA.getValue(columnId) as string;
  const timeB = rowB.getValue(columnId) as string;

  return getDateTime(timeA).getTime() - getDateTime(timeB).getTime();
};
